import { theme, Button, Page, Paragraph } from '@scouts/ui'

export const ChunkLoadError = () => (
    <Page>
        <Page.Section background={theme.neutral.backgroundLight}>
            <Paragraph>La aplicación se ha actualizado. Por favor, refresca la página.</Paragraph>
            <Button onClick={() => window.location.reload()}>Refrescar</Button>
        </Page.Section>
    </Page>
)
